import moment from "moment";
import { useGetTicketDetailsHistoryQuery } from "../../../../../../features/superAdmin/ticketService/ticket/ticket.api";

const TicketHistoryTab = ({ ticketId }: { ticketId: number }) => {
  const { data: histories } = useGetTicketDetailsHistoryQuery({
    params: {
      ticketLogId: ticketId,
    },
  });
  return (
    <div className="h-[calc(100vh_-_385px)] w-full overflow-auto px-1">
      {histories?.data?.map((item: any) => (
        <div key={item.id} className="p-4 bg-white shadow rounded-md mb-2">
          <div className="flex justify-start items-center">
            <p>Sender :</p>
            <p className="pl-2">{item?.creator_name}</p>
          </div>

          <div className="flex justify-start items-center">
            <p>Receiver :</p>
            <p className="pl-2">{item?.receiver?.officialInfo?.name}</p>
          </div>

          <p>{item?.text}</p>
          <p className="text-[#3D4A5C] text-base">
            {moment(item?.created_at).fromNow()}
          </p>
        </div>
      ))}
    </div>
  );
};

export default TicketHistoryTab;
